import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Layout from '../../components/Layout/Layout';
import {
  SubTitleH2,
  ComponentDataTable,
  ModalConfirm,
  ModalAction
} from '../../components';
import { columns, columnsAdmin } from './columns';
import { getQuizReviews, deleteQuizReview } from '../../actions/score';
import { closeImportWindow } from '../../actions/student';
import { AbilityContext, Can } from '../../config/ability-context';

class ScoreScreen extends Component {
  constructor() {
    super();
    this.state = {
      modalShowConfirm: false,
      modalData: {},
      modalShowAI: false,
      modalDataAI: {}
    };
  }

  handleButtonClick = (item, action) => {
    if (action === 'edit') {
      const { history } = this.props;
      history.push(`/score/add/${item.id}`);
    } else {
      this.setState({
        modalShowConfirm: true,
        modalData: {
          id: item.id,
          action: 'delete',
          title: 'ELIMINAR REVISIÓN',
          message: '¿Estás seguro que deseas eliminar esta revisión?'
        }
      });
    }
  };

  setModalShowConfirm = state => {
    this.setState({
      modalShowConfirm: state
    });
  };

  setModalShowAI = state => {
    this.setState({
      modalShowAI: state
    });
  };

  handleAIUpload = () => {
    const { dispatch } = this.props;
    dispatch(closeImportWindow());
    this.setState({
      modalShowAI: true,
      modalDataAI: {
        create: true,
        action: 'edit',
        form: 'upload-file',
        title: 'INGRESA PUNTAJES CON IA - AUTO'
      }
    });
  };

  queryDispatch = data => {
    const { dispatch, signedIn } = this.props;
    if (signedIn) {
      dispatch(getQuizReviews(data));
    }
  };

  handleDelete = reviewId => {
    const { dispatch } = this.props;
    dispatch(deleteQuizReview({ id: reviewId }));
    this.setModalShowConfirm(false);
  };

  render() {
    const { history, ongoingRequest, quizReviews } = this.props;
    const {
      modalShowConfirm,
      modalData,
      modalShowAI,
      modalDataAI
    } = this.state;
    const { context } = this;

    return (
      <Layout>
        <Container fluid>
          <Row>
            <Col role="main">
              <div className="section">
                <Row>
                  <Col md={7}>
                    <SubTitleH2 text="Puntajes" />
                  </Col>
                  <Can I="transition" a="Section">
                    <Col md={5} style={{ textAlign: 'right' }}>
                      <Row>
                        <Col>
                          <Button
                            variant="secondary"
                            className="mr-2"
                            onClick={() => this.handleAIUpload()}
                          >
                            Automático IA
                          </Button>
                          <Button onClick={() => history.push('/score/add')}>
                            Ingresar Puntajes
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Can>
                </Row>
                <ComponentDataTable
                  columns={
                    context.can('manage', 'QuizReview')
                      ? columnsAdmin(this.handleButtonClick)
                      : columns(this.handleButtonClick)
                  }
                  onRequest={
                    ongoingRequest.getQuizReviews ||
                    ongoingRequest.deleteQuizReview
                  }
                  data={quizReviews.data}
                  totalRows={quizReviews.amount}
                  reduxDispatch={this.queryDispatch}
                />
                <ModalConfirm
                  show={modalShowConfirm}
                  data={modalData}
                  onHide={() => this.setModalShowConfirm(false)}
                  action={this.handleDelete}
                />
                <ModalAction
                  show={modalShowAI}
                  data={modalDataAI}
                  title="edit"
                  onHide={() => this.setModalShowAI(false)}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Layout>
    );
  }
}
ScoreScreen.contextType = AbilityContext;

const mapStateToProps = state => {
  const { ongoingRequest, quizReviews } = state.score;

  const { user, signedIn } = state.auth;
  return {
    ongoingRequest,
    signedIn,
    quizReviews,
    user
  };
};
export default connect(mapStateToProps)(ScoreScreen);
